import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const SvgPets = (props)=>/*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        ...props,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#fff",
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.31,
                d: "M24 45.913c12.102 0 21.913-9.81 21.913-21.913S36.103 2.087 24 2.087 2.087 11.897 2.087 24 11.897 45.913 24 45.913Z"
            }),
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#Pets_svg__a)",
                children: [
                    /*#__PURE__*/ jsxs("g", {
                        clipPath: "url(#Pets_svg__b)",
                        children: [
                            /*#__PURE__*/ jsx("path", {
                                fill: "#000",
                                d: "M31.08 10.697c-3.51.066-4.901 2.156-6.292 4.377-8.42 5.02-10.971 11.278-10.732 20.381.02.842.73 1.504 1.583 1.504 2.685 0 11.336-.19 14.184-.256.835-.019.355-1.701.393-2.524.202-4.367 1.094-7.553.739-13.887"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                fill: "#000",
                                d: "M29.152 22.268c.067.198 2.782 12.865 2.782 12.865 1.39.331 1.39 1.57 1.39 1.57h-3.577l-2.522-9.472M31.08 10.697c-3.117-1.106-2.781-.983-4.24 0-1.457.983-.134 3.526 1.66 2.94 1.793-.586 2.58-2.94 2.58-2.94"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                fill: "#000",
                                d: "M29.488 10.508c1.515-.16 2.848-.945 3.376-.265 1.141 1.456.201 1.825.201 1.825M15.63 36.967c-6.551 0-10.666-2.949-6.877-10.445.115-.227.48-.104.412.15-2.129 7.998 5.17 7.932 6.464 6.902"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                fill: "#fff",
                                d: "M18.449 37.035c-1.669-5.238 5.773-12.8 5.927-16.175l-.067-1.579 2.043.983c1.86.256 1.668 1.418 2.656 1.797.154.075.988.378.988.378.077 2.174-2.58 2.325-2.58 2.325 1.592 4.046-.604 8.158-.604 8.158l.834 2.846c.816-.142 1.036 1.125 1.036 1.125l-10.224.151z"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeMiterlimit: 10,
                                d: "M18.88 36.77c-4.238-.2-4.171-1.768-1.457-4.444 2.455-2.42.393-2.873-.393-2.807"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                stroke: "#000",
                                strokeMiterlimit: 10,
                                strokeWidth: 1.31,
                                d: "M22.86 22.948c1.21 2.988 5.832 2.335 5.832 2.335"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                stroke: "#fff",
                                strokeMiterlimit: 10,
                                d: "M24.462 14.885c.806 2.94 6.493 6.258 7.356 5.606"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#000",
                        d: "M31.003 20.065c.154-.936 2.168-2.486 3.865-2.817 1.458-.284 3.606-1.03 3.74-4.869-1.774.048-2.79 0-4.133-.085-.413-1.2-1.007-2.25-4.479-1.777"
                    })
                ]
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "Pets_svg__a",
                        children: /*#__PURE__*/ jsx("path", {
                            fill: "#fff",
                            d: "M7.304 9.913h31.304v27.13H7.304z"
                        })
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "Pets_svg__b",
                        children: /*#__PURE__*/ jsx("path", {
                            fill: "#fff",
                            d: "M7.304 9.913H33.43v27.13H7.304z"
                        })
                    })
                ]
            })
        ]
    });
const Pets = SvgPets;
export { Pets as default };
